// src/utils/api.js
// Thin wrapper around fetch() that always hits /api/*
// SWA injects the auth cookie automatically — no token juggling needed in the frontend.

const BASE = "/api";

async function request(method, path, body) {
  const opts = {
    method,
    headers: { "Content-Type": "application/json" },
  };
  if (body !== undefined) opts.body = JSON.stringify(body);
  const res = await fetch(`${BASE}${path}`, opts);
  if (res.status === 204) return null;
  const data = await res.json();
  if (!res.ok) throw new Error(data?.error || `Request failed: ${res.status}`);
  return data;
}

// Graph user search
export const searchGraphUsers = (q) => request("GET", `/graph/users?q=${encodeURIComponent(q)}`);

// ── Generic client for the three resource types (SaaS Applications, Local
// Applications, Shared Credentials). Systems has been removed — this used
// to have its own named exports (getSystems/createSystem/etc.) alongside
// this factory; those are gone along with the backend endpoints they called.
export function createApiClient(resource) {
  return {
    list:        ()               => request("GET",    `/${resource}`),
    get:         (id)             => request("GET",    `/${resource}/${id}`),
    create:      (body)           => request("POST",   `/${resource}`, body),
    update:      (id, body)       => request("PUT",    `/${resource}/${id}`, body),
    remove:      (id)             => request("DELETE", `/${resource}/${id}`),
    listUsers:   (id)             => request("GET",    `/${resource}/${id}/users`),
    addUser:     (id, body)       => request("POST",   `/${resource}/${id}/users`, body),
    updateUser:  (id, uid, body)  => request("PUT",    `/${resource}/${id}/users/${uid}`, body),
    removeUser:  (id, uid)        => request("DELETE", `/${resource}/${id}/users/${uid}`),
    submitAudit: (id, body)       => request("POST",   `/${resource}/${id}/audit`, body),
  };
}

export const saasApplicationsApi  = createApiClient("saas-applications");
export const localApplicationsApi = createApiClient("local-applications");
export const sharedCredentialsApi = createApiClient("shared-credentials");

